export interface CreditingFormProps {
    customerNumber: number | string | undefined;
    customerName: string;
    invoiceNumber: string | number;
    zendesk: string | number;
    gsm: number | string;
    amount: string | number;
    dueDate: string;
}

export function getCreditingFormUrl(data: CreditingFormProps): string {
	return `https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=Dbqc3nSRxkmg70TZ6wtbcPq8ZEuOVW9FlzM_h9ijaAtUQkozTTJFNjI4Ulk1SlA1RlVSUktNSzhCTS4u&r6323d5e4ab97492cab65db72c57b07cf=%22Unifon%22&ra41d6e2256f74a1ab02a2756029303d4=${data?.zendesk}%20&r0c6492da35c04f20ac9c832b7b4ab8ba=${data?.customerNumber}&rf02b1de20cd546659bc4297a5e8e6ed5=${data?.customerName}&r27c2a01e45d7424c996b756cb96c8fa5=${data?.gsm}&r6447f27ecf4748fd9d329ef0b532523c=${data?.invoiceNumber}&r4646a09f5a0c4540b63cadbfd4008cce=%22${data?.dueDate}%22&r1f4d71189692404aa0fefc07c5e7e01b=%22Goodwill%22&r4494a1e6bc4747a09aa982c8573ea402=${data?.amount}&r1e484faff1e74621bb91faa517e5e423=%22Nei%22`;
}